import { TUseCasesApiTags, TUseCaseTags } from '../types';
import {
  IMutateTestCaseRequestV2,
  IUseCaseResource,
  IUseCaseV2,
} from '../types/useCasesV2';
import { requestWithOptions } from './helper';

const basePath = import.meta.env.REACT_APP_API_ENDPOINT_USE_CASES || '/';

export const getUseCasesV2 = async (envId: string) => {
  const path = `${basePath}/v2/usecase/${envId}`;
  const result = await requestWithOptions(path, { method: 'GET' });

  return result as IUseCaseV2[];
};

export const getUseCasesResources = async (envId: string) => {
  const path = `${basePath}/v2/usecase/${envId}/resources`;
  const result = await requestWithOptions(path, { method: 'GET' });

  return result as IUseCaseResource[];
};

export const selectUseCase = async (
  envId: string,
  useCaseId: string,
  selected: boolean,
) => {
  const path = `${basePath}/v2/usecase/${envId}/carrier-selected`;
  const result = await requestWithOptions(path, {
    method: 'POST',
    body: JSON.stringify({
      carrier_selected: selected,
      id: useCaseId,
    }),
  });

  return result;
};

export const getSelectedApis = async (envId: string) => {
  const path = `${basePath}/v2/api/${envId}/metadata`;
  const result = await requestWithOptions(path, { method: 'GET' });

  return result;
};

export const getSelectedApiTests = async (envId: string) => {
  const path = `${basePath}/v2/api/${envId}/test-execution-results`;
  const result = await requestWithOptions(path, { method: 'GET' });

  return result;
};

export const getSelectedUseCaseTests = async (
  envId: string,
  selectedTags: string[],
) => {
  const tagsParam = encodeURIComponent(selectedTags.join(','));
  const path = `${basePath}/v2/usecase/${envId}/test-execution-results?tags=${tagsParam}`;
  const result = await requestWithOptions(path, { method: 'GET' });

  return result;
};

export const getSelectedOptions = async (envId: string) => {
  const path = new URL(`${basePath}/v2/api/${envId}/labels`);

  const response = await requestWithOptions(path, { method: 'GET' });
  return response;
};

export const getApisTestData = async (
  envId: string,
  apiTag: TUseCaseTags | TUseCasesApiTags,
  testcaseTag: string,
) => {
  const path = `${basePath}/v2/api/${envId}/testcase-args/api/${apiTag}/testcase/${testcaseTag}`;
  const result = await requestWithOptions(path, { method: 'GET' });

  return result;
};

export const getUseCaseTestData = async (
  envId: string,
  useCaseTag: TUseCaseTags | TUseCasesApiTags,
  testcaseTag: string,
) => {
  const path = `${basePath}/v2/usecase/${envId}/testcase-args/usecase/${useCaseTag}/testcase/${testcaseTag}`;
  const result = await requestWithOptions(path, { method: 'GET' });

  return result;
};

export const postUseCaseTestData = async (
  envId: string,
  payload: IMutateTestCaseRequestV2,
) => {
  const options = {
    body: JSON.stringify(payload),
    method: 'POST',
  };
  const path = `${basePath}/v2/usecase/${envId}/testcase-args`;
  const result = await requestWithOptions(path, options);

  return result;
};

export const postApiTestData = async (
  envId: string,
  payload: IMutateTestCaseRequestV2,
) => {
  const options = {
    body: JSON.stringify(payload),
    method: 'POST',
  };
  const path = `${basePath}/v2/api/${envId}/testcase-args`;
  const result = await requestWithOptions(path, options);

  return result;
};
